/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_Hint_Ppl_ArmsInputs */

const en_us2_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push, pull, legs and a day for arms and shoulders.`)
};

const pt_br2_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar, puxar, pernas e um dia de braços e ombros.`)
};

const es_419_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje, tirón, piernas y un día de brazos y hombros.`)
};

const pt_pt2_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar, puxar, pernas e um dia de braços e ombros.`)
};

const fr_fr2_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée, tirage, jambes et un jour pour les bras et les épaules.`)
};

const de_de2_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken, Ziehen, Beine und ein Tag für Arme und Schultern.`)
};

const it_it2_profile_editors_split_hint_ppl_arms = /** @type {(inputs: Profile_Editors_Split_Hint_Ppl_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta, tirata, gambe e un giorno per braccia e spalle.`)
};

/**
* | output |
* | --- |
* | "Push, pull, legs and a day for arms and shoulders." |
*
* @param {Profile_Editors_Split_Hint_Ppl_ArmsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_hint_ppl_arms = /** @type {((inputs?: Profile_Editors_Split_Hint_Ppl_ArmsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Hint_Ppl_ArmsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_hint_ppl_arms(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_hint_ppl_arms(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_hint_ppl_arms(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_hint_ppl_arms(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_hint_ppl_arms(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_hint_ppl_arms(inputs)
	return en_us2_profile_editors_split_hint_ppl_arms(inputs)
});
export { profile_editors_split_hint_ppl_arms as "profile-editors.split_hint_ppl_arms" }